// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AccountViewListingAdproductDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
} from '../..';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeSpotlightedOnly?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  startKeyExclusive?: string;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/advertising';

/**
 * Get single family customer account view property listing advertising
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AdvertisingParams, never, AccountViewListingAdproductDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_advertising_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/list';

/**
 * Get single family customer account view property list
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_list = (
  getParams: ListParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ListParams, never, AccountViewListingsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/options';

/**
 * Get single family customer account view property listing options
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_options = (
  getParams: OptionsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<OptionsParams, never, AccountViewListingOptionsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_options_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/prospects';

/**
 * Get single family customer account view property prospects
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ProspectsParams, never, AccountViewListingProspectsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_prospects_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/sources';

/**
 * Get single family customer account view property listing sources
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SourcesParams, never, AccountViewListingSourcesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_sources_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path =
  '/api/web/v1/users/accountView/zram/singleFamily/properties/status';

/**
 * Get single family customer account view property listing status
 */
export const RentalManagerAccountViewZramSingleFamilyWebApiHandler_status = (
  getParams: StatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<StatusParams, never, AccountViewListingStatusOverviewDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerAccountViewZramSingleFamilyWebApiHandler_status_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
